/* @flow */

import React from 'react';
import ReactDOM from 'react-dom';
import is from 'is_js';
import { ThemeProvider } from 'styled-components';
import Modal from './Modal';

import { getLabel } from '../utils/i18n';

const TYPE = 'confirm';

export default function confirm(config: Object) {
  const div = document.createElement('div');
  window.document.body.appendChild(div);

  function destroy() {
    const unmountResult = ReactDOM.unmountComponentAtNode(div);
    if (unmountResult && div.parentNode) {
      div.parentNode.removeChild(div);
    }
  }

  function render(newConfig: Object) {
    const {
      content,
      onConfirm,
      onCancel,
      i18n,
      theme,
    } = newConfig;
    const modalContent = is.undefined(content) ? null : content;
    const okText = getLabel('exchange-common-confirm', i18n);
    const cancelText = getLabel('exchange-common-cancel', i18n);
    function _hideModal() {
      if (is.function(onCancel)) {
        newConfig.onCancel();
      }
      destroy();
    }
    function _onConfirm() {
      if (is.function(onConfirm)) {
        newConfig.onConfirm();
      }
      destroy();
    }
    ReactDOM.render(
      <ThemeProvider theme={theme}>
        <Modal
          type={TYPE}
          closeBtn={true}
          isOpen={true}
          hideModal={_hideModal}
          confirm={_onConfirm}
          okText={okText}
          cancelText={cancelText}
          {...newConfig}
        >
          {modalContent}
        </Modal>
      </ThemeProvider>, div);
  }
  render({ ...config });
}
